import React from "react";
import axios from "axios";
import { setup as URI_SETUP } from "../../../../config/api";
import { Select, Table, Icon, Badge, Modal, Button, notification} from 'antd';
import ProductionList from "./production/ProductionList";
import ProductionEdit from "./production/ProductionEdit";


const Option = Select.Option;
const uri_production = URI_SETUP+"production";

class Production extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            section_active              : "budget-list",
            production_list             : [],
            budget_lst_rows             : [],
            reference_years             : [],
            production_selected         : null,
            modal_delete_item           : false,
            modal_set_live              : false,
            modal_set_offline           : false,
            active_production               : {
                                            period              : "",
                                            year                : "",
                                            reference_year      : "",
                                            depth               : "",
                                            capture_format      : "",
                                            expected_growth     : 0,
                                            growth              : 0,
                                            matrix              : [],
                                            status              : "default"
                                        }
            }
        this.setActiveProductionSection = this.setActiveProductionSection.bind(this);
        this.updateActiveProduction = this.updateActiveProduction.bind(this);
        this.resetActiveProduction = this.resetActiveProduction.bind(this);
    }

    componentWillMount(){
        this.startProductionSetup();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.hotel_selected != this.props.hotel_selected) {
            this.startProductionSetup();
            this.resetActiveProduction();
            this.setActiveProductionSection("budget-list");
        }
    }

    // ----------------------- Handlers -----------------------

    handleNewProduction(e) {
        let self = this;
        e.preventDefault();
        self.resetActiveProduction();
        self.setActiveProductionSection("budget-edit");
    }

    HandlerProductionEdit(row){
        let self = this;
        self.setState({ 
            active_production : row
            })
        self.setActiveProductionSection("budget-edit");
    }

    handleRemoveItem(_id) {
        let self = this;
        self.setState({ 
            modal_delete_item               : true,
            production_selected             : _id
            })
        
    }

    handleSetLiveItem(_id) {
        let self = this;
        self.setState({ 
            modal_set_live                  : true,
            production_selected             : _id
            })  
    }

    handleConfirmSetOfflineModal(_id) {
        let self = this;
        self.setState({ 
            modal_set_offline                : true,
            production_selected             : _id
            })  
    }

    handleConfirmSetOffline = e => {
        let formData = new FormData();
        this.setState({ modal_set_offline : false });

        notification.open({
            message: 'Notification',
            description: "We started to remove the Production data of your MagnumLeap panels."
          });
        
        formData.append('api_token',localStorage.getItem("api_token"));
        formData.append('mode',"set_as_offline");

        axios.post(uri_production+"/"+this.state.production_selected+"/destroy", formData)
                    .then(request => {
                        let budget_lst_rows=this.mapProductionRows(request.data)
                        this.setState({     
                            budget_lst_rows                 : budget_lst_rows,
                            production_list                 : request.data
                        });
                        notification.open({
                            message: 'Notification',
                            description: "This action was successfully completed."
                          }); 
                    })
                    .catch(error => {
                        notification.open({
                            message: 'Unsuccessful',
                            description: "Process Unsuccessful please try again"
                          });
                    });
        this.setState({
            modal_set_live        : false,
            production_selected   : null
        });
        
      };


    handleConfirmSetLive = e => {
        let formData = new FormData();

        notification.open({
            message: 'Notification',
            description: "Now We going to process this data to set it up as a live Production, this could take several minutes."
          });

        formData.append('api_token',localStorage.getItem("api_token"));
        formData.append('mode',"set_as_visible");

        axios.post(uri_production+"/"+this.state.production_selected, formData)
                    .then(request => {
                        this.startProductionSetup(); 
                        notification.open({
                            message: request.data.result.type,
                            description: request.data.result.message
                          });
                    })
                    .catch(error => {
                        notification.open({
                            message: 'Unsuccessful',
                            description: "Process Unsuccessful please try again"
                          });
                    });
        this.setState({
            modal_set_live        : false,
            production_selected   : null
        });
        
      };
    
      handleCancelSetLive = e => {
        this.setState({
            modal_set_live        : false,
            production_selected   : null
        });
      };

      handleCancelSetOffline = e => {
        this.setState({
            modal_set_offline        : false,
            production_selected   : null
        });
      };

    // ----------------------- Functions -----------------------

    resetActiveProduction(){
        let self = this;
        self.setState({ 
            active_production    : {
                                period              : "",
                                year                : 0,
                                reference_year      : 0,
                                depth               : "",
                                capture_format      : "",
                                expected_growth     : 0,
                                growth              : 0,
                                matrix              : [],
                                status              : "default"
                            }
            })
    }
    
    updateActiveProduction(active_production){
        let self = this;
        self.setState({ 
            active_production      : active_production
            })
    }

    startProductionSetup(){
        let self = this;
        axios.get(uri_production, { 
            params: {
                api_token       : localStorage.getItem("api_token"),
                mode            : "define",
                property_id     : self.props.hotel_selected
            }
        }).then(request => { 
            let budget_lst_rows=self.mapProductionRows(request.data.production_list)
            self.setState({ 
                production_list                : request.data.production_list,
                budget_lst_rows            : budget_lst_rows,
                reference_years            : request.data.reference_years,
            }) 
        })
    }

    mapProductionRows(production_list){
        let maped_rows=[];
        let maped_row=[];
        let self=this;
        production_list.map(function(row, i) {
            maped_row={
                key                     : i,
                _id                     : row._id,
                year                    : <span><Badge status={row.status} /> {row.year}</span>,
                depth                   : row.depth,
                created_by              : row.created_by.name,
                period                  : row.period,
                created_at              : row.created_at.substring(0,10),
                actions                 : <div>
                                            <i className="fa fa-pencil edit clickable" onClick={self.HandlerProductionEdit.bind(self,row)} ></i> 
                                            <i className="fa fa-upload live clickable" onClick={self.handleSetLiveItem.bind(self,row._id)} ></i>
                                            <i className="fa fa-times-circle remove clickable" onClick={self.handleConfirmSetOfflineModal.bind(self,row._id)} ></i> 
                                            <i className="fa fa-trash remove clickable" onClick={self.handleRemoveItem.bind(self,row._id)} ></i> 
                                          </div>
                
            };
            maped_rows.push(maped_row);
            });
        return maped_rows;
    }
    
    setActiveProductionSection(section){
        let self = this;
        self.setState({ 
            section_active      : section
            })
    }

     confirmItemDeletion = e => {
        let formData = new FormData();
        this.setState({ modal_delete_item : false });

        notification.open({
            message: 'Notification',
            description: "MagnumLeap started the remove process of the Production data."
          });
        
        formData.append('api_token',localStorage.getItem("api_token"));
        axios.post(uri_production+"/"+this.state.production_selected+"/destroy", formData)
                    .then(request => {
                        let budget_lst_rows=this.mapProductionRows(request.data)
                        this.setState({     
                            budget_lst_rows                 : budget_lst_rows,
                            production_list                 : request.data
                        });
                        notification.open({
                            message: 'Notification',
                            description: "This action was successfully completed."
                          }); 
                    })
                    .catch(error => {
                        notification.open({
                            message: 'Unsuccessful',
                            description: "Process Unsuccessful please try again"
                          });
                    });
        this.setState({
            modal_set_live        : false,
            production_selected   : null
        });
        
      };

    cancelConfirmItemDeletion = e => {
        this.setState({
            modal_delete_item        : false,
            production_selected      : null
        });
      };

    // ----------------------- Renders -----------------------

    renderConfirmSetLive() {
        return (
            <Modal
              title="Confirm"
              visible={this.state.modal_set_live}
              onOk={this.handleConfirmSetLive}
              onCancel={this.handleCancelSetLive}
            >
              <p>Are you sure?. If you confirm, the selected data going to replace the actual one.</p>
            </Modal>
        );
      }

    renderConfirmSetOffiline() {
    return (
        <Modal
            title="Confirm"
            visible={this.state.modal_set_offline}
            onOk={this.handleConfirmSetOffline}
            onCancel={this.handleCancelSetOffline}
        >
            <p>Are you sure?. The actual data in MagnumLeap panels will be lost.</p>
        </Modal>
    );
    }

    renderConfirmItemDeletion() {
        return (
            <Modal
                title="Confirm"
                visible={this.state.modal_delete_item}
                onOk={this.confirmItemDeletion}
                onCancel={this.cancelConfirmItemDeletion}
            >
                <p>Are you sure?. All the information of this Production will be remove.</p>
            </Modal>
        );
        }

    render() {
        return (
            <section>
                <div className={this.state.background_filter}>
                    <div className="top-form ">
                            <div className="form-row">
                                <div className="col col-md-3">
                                    {this.props.renderSelectHotels()}
                                </div>
                                <div className="col col-md-3">
                                    <button className={"blue " + this.state.status_new_budget} onClick={this.handleNewProduction.bind(this)} >NEW PRODUCTION GRID</button>
                                </div>
                            </div>
                    </div>
                   
                    <div className="head-content "> 
                        <div className="icon col-md-2 px-2">
                            <h1>Setup</h1>
                            <h2>Production</h2>
                        </div>
                        <div className="col-md-8 px-2">    
                            
                            <div className="description">
                                <p className="desc-no-icon"><strong>Now, manage your production info, </strong> <br/> Maybe your PMS is not allowing you to get all your production information, or may be you are just testing MagnumLeap, whichever case it is you can manually add your production info to have access to see all your information in Magnumleap  </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12"> 
                        <div className="layout-budget">
                            { this.state.section_active == "budget-list" &&
                            <div className={"budget-list " }>
                                <ProductionList
                                    setActiveProductionSection = {this.setActiveProductionSection}
                                    app={this}
                                    handleNotification = {this.props.handleNotification}
                                    
                                />
                            </div>
                            }
                            { this.state.section_active == "budget-edit" &&
                            <div className={"budget-edit "}>
                                <ProductionEdit
                                    setActiveProductionSection = {this.setActiveProductionSection}
                                    updateActiveProduction = {this.updateActiveProduction}
                                    resetActiveProduction  = {this.resetActiveProduction}
                                    app={this}
                                    active_production = {this.state.active_production}
                                    hotel_selected = {this.props.hotel_selected}
                                    handleNotification = {this.props.handleNotification}
                                />
                            </div>
                            }
                        </div>
                    </div>
                </div>
                { this.renderConfirmItemDeletion()}
                { this.renderConfirmSetLive() }
                { this.renderConfirmSetOffiline() }
            </section>
        )
    }

}

export default Production


// WEBPACK FOOTER //
// ./src/Setup/modules/setup/views/property/Production.js